import React from 'react'
import { WhatsApp } from '@mui/icons-material'
import WhatsAppQR from '../assets/img/whatsAppQR.png'
// import instaLoop from '../assets/img/instaLoop.gif'
function AboutMe() {
    const [showInsta, setShowInsta] = React.useState(true)
    const onClick2 = () => setShowInsta(false)

    return (
        <div id="about" style={{display:"flex",alignItems:"center"}}>
            {/* <img className="instaLoop" src={instaLoop} alt="Iphone Loop" width="30%"/> */}
            <div className="aboutMe">
                <h1>About Me <strong style={{color:"#f5576c"}}>.</strong></h1>
                <p className="para" style={{width:"70%", marginLeft:"auto",marginRight:"auto"}}>A recent graduate with a strong technical background in full-stack development, who possess a range of skills in front-end and back-end programming.
                <br/>
                <br/>
                Is seeking an entry-level role in Full Stack Development to build upon his knowledge and contribute to the success of an innovative team. </p>
                <br/>
                <br/>
                <p className="cartoonText" style={{fontSize:"150%",color:"#f5576c",textAlign:"left"}}> ~ Hey, That's me!</p>
            
                {
                    showInsta ?
                
                <div className="idCard idCard2" style={{marginLeft:"auto",marginRight:"auto",width:"70%",display:"flex",flexDirection:"column",marginTop:30,border:"2px solid lightgrey",borderRadius:10}}> 
                        <div style={{padding:5,width:"100%",backgroundColor:"#ededed",fontSize:"150%",borderBottom:"1px solid lightgrey",height:25,borderTopLeftRadius: 10,borderTopRightRadius:10,display:"flex",alignItems: "center",justifyContent:"start"}}>
                            <h1 onClick={onClick2} style={{zIndex:50,marginTop:10,cursor:"pointer"}}><strong style={{color:"#FE5E58"}}> .</strong></h1>
                            <h1 style={{marginTop:10}}><strong style={{color:"#FEBD2C"}}>.</strong></h1>
                            <h1 style={{marginTop:10}}><strong style={{color:"#27C841"}}> .</strong></h1>
                        </div>
                        <a href="https://wa.me/917879376494?text=Hey%20Ayush!">
                        <div style={{display:"flex", alignItems: 'center',padding:20}}>
                            <img src={WhatsAppQR} alt='img' className="dp2"/>
                            <div className="instaTag" style={{padding:20 , fontSize:"80%"}}>
                                <h1>@lets catch up </h1>
                                <h3 id='justAnother' style={{fontFamily:"EBGaramondRegular",opacity:0.3,marginTop:-10}}> Scan my whatsApp QR Code! <span> <WhatsApp/> </span> </h3>
                            </div>
                        </div>
                        </a>
                </div>
                
                : 
                
                <br/> 

                }

            </div>
        </div>
    )
}

export default AboutMe
